<template>
  <div id="app">
    <div id="nav">
     <router-view></router-view>
    </div>
  </div>
</template>

<style lang="scss">
  *{
    padding: 0;
    margin: 0;
  }
  #app{
    width: 100%;
    height: 100%;
  }
  #nav.router-link-active{
        background: #24C0EA;
        color: #fff !important;
    }
</style>
<script>

export default {
  data() {
    return {
      
      }
  },
  methods:{

  },
  components:{
    
  }
}
</script>
